var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Falcon } from 'modules/macro';
import { Container, IconContainer } from './styled';
const isSelected = (selectedValue, value) => {
    if (Array.isArray(selectedValue)) {
        return value !== undefined && selectedValue.includes(value);
    }
    return selectedValue === value;
};
/* eslint-disable react/prop-types */
const SelectOption = forwardRef((props, forwardedRef) => {
    const { name, children, selectedValue, value, disabled, onClick, onKeyDown } = props, restProps = __rest(props, ["name", "children", "selectedValue", "value", "disabled", "onClick", "onKeyDown"]);
    const selected = isSelected(selectedValue, value);
    return (<Container {...restProps} ref={forwardedRef} type="button" tabIndex={selected ? 0 : -1} $selected={selected} aria-selected={selected} name={name} value={value} disabled={disabled} onClick={onClick} onKeyDown={onKeyDown}>
      {children}
      <IconContainer>
        {selected ? <Falcon icon="check" $size={16} $color="text.light"/> : <Falcon icon="chevron-right" $size={16}/>}
      </IconContainer>
    </Container>);
});
SelectOption.displayName = 'SelectOption';
export default SelectOption;
